// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-7ee92e5c]{font-size:17px;line-height:22px}.el-row[data-v-7ee92e5c]{align-items:center;margin:8px 0}.more-link[data-v-7ee92e5c]{text-decoration:underline;font-size:14px;font-size:clamp(14px,3.86vw,16px);line-height:18px;line-height:1.2;color:#2c353b;margin-left:auto;text-align:right;cursor:pointer}", ""]);
// Exports
module.exports = exports;
